import { Address, PersonInfoCommon } from '../types/CommonModel';
import AxiosService from './axiosService';
import store from '@/store/store';
import { defaultConfig } from '@/cms/api/ApiConfig';

const axiosService = new AxiosService();
axiosService.setWithCredentials(false);

const getDetailUrl = (id: string): string => {
	const proxyBase = `${defaultConfig.baseUrl}${store.state.openServiceCalculatorUrl}`;
	return `${proxyBase}/adresser/${id}`;
};

export const mapDarAddress = async (address: Address | PersonInfoCommon, dar: any) => {
	address.address = dar.matchText;

	const id: string = dar.id ?? dar.data?.id;
	const res = await axiosService.getQuery(getDetailUrl(id), {});

	if (!res?.data) {
		return;
	}

	const detail = res.data.adresse;
	const hn = detail?.husnummer;
	address.zipCode = hn?.postnummer?.postnr;
	address.zipName = hn?.postnummer?.navn;
	address.streetName = hn?.vejnavn;
	address.houseNr = hn?.husnummertekst;
	address.floorNr = detail?.etagebetegnelse ?? null;
	address.doorNr = detail?.doerbetegnelse ?? null;
	address.streetCode = hn?.navngivenvejkommunedel?.vejkode;
	address.kvhxValue = hn?.['x-abgroup']?.kvhx;
};

export const handleDarAddressSearch = async (
	address: Address | PersonInfoCommon,
	homeAddress: Address | PersonInfoCommon,
	dar: any
) => {
	if (dar?.matchText) {
		await mapDarAddress(address, dar);
		copyAddress(address, homeAddress);
		return true;
	}

	resetAddress(address);
	resetAddress(homeAddress);
	return false;
};

export const copyAddress = (from: Address | PersonInfoCommon, to: Address | PersonInfoCommon) => {
	to.address = from.address;
	to.zipCode = from.zipCode;
	to.zipName = from.zipName;
	to.streetName = from.streetName;
	to.houseNr = from.houseNr;
	to.floorNr = from.floorNr;
	to.doorNr = from.doorNr;
	to.streetCode = from.streetCode;
	to.kvhxValue = from.kvhxValue;
};

export const resetAddress = (address: Address | PersonInfoCommon) => {
	address.address = undefined;
	address.zipCode = undefined;
	address.zipName = undefined;
	address.streetName = undefined;
	address.houseNr = undefined;
	address.floorNr = undefined;
	address.doorNr = undefined;
	address.kvhxValue = undefined;
	address.streetCode = undefined;
};
